import { useEffect, useState } from 'react'
import { Breadcrumb, Button, List, Card, ConfigProvider, Empty } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import { Droplet, Layout, Edit, Plus, Trash } from 'react-feather'
import { QueryEditor } from 'Components'
import WeaverService from 'Services/WeaverService'
import { Macro } from 'Model'

{ Meta } = Card
import {
  EmptyContainer,
  PageContainer,
  StyledList,
  StyledFooter
} from '../shared'
import './index.scss'

renderEmpty = ->
  <EmptyContainer>
    <div />
    <Empty />
    <div />
  </EmptyContainer>

ActionItem = ({ Icon, fn, rest... }) ->
  <Button
    type="text"
    icon={<Icon style={{ height: 20 }} />}
    size="small"
    disabled={!WeaverService.userCanEdit()}
    { rest... }
  />

Macros = ({ match, history }) ->

  { path, params: { spaceId }} = match
  [isLoading, setIsLoading] = useState(true)
  [listData, setListData] = useState([])

  useEffect( ->
    ( ->
      loadMacros()
    )()
    undefined
  , [])

  loadMacros = ->
    setIsLoading(true)
    macros = await Macro.list()
    setListData(_.orderBy(macros.flat(), (m) -> m.get('name')))
    setIsLoading(false)

  destroy = (item) ->
    setIsLoading(true)
    await item.destroy()
    loadMacros()

  <PageContainer>
    <Breadcrumb style={{ margin: 20, marginBottom: 0 }}>
      <Breadcrumb.Item>
        { Weaver.getInstance().currentProject()?.name() }
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to="/#{ spaceId }/settings/forms">
          Forms
        </Link>
      </Breadcrumb.Item>
    </Breadcrumb>
    <ConfigProvider renderEmpty={renderEmpty}>
      <StyledList
        itemLayout="horizontal"
        size="large"
        dataSource={listData}
        loading={isLoading}
        className="macros-list-container"
        renderItem={(item) -> (
          avatar = <Droplet />
          <List.Item
            key={item.id()}
            actions={[
              <ActionItem
                Icon={Edit}
                onClick={ -> history.push("/#{ spaceId }/settings/forms/#{ item.id() }")}
                type="link"
              />,
              <ActionItem
                Icon={Trash}
                onClick={ -> destroy(item)}
                danger
              />
            ]}
          >
            <List.Item.Meta
              avatar={avatar}
              title={item.get('name')}
              description={_.startCase(_.lowerCase(item.get('type')))}
            />
            <QueryEditor
              height="100px"
              width="50%"
              value={JSON.stringify(item.get('configBlob'),  null, 4)}
              style={{ transform: 'scale(0.75)', borderRadius: 9, margin: '-10px 0' }}
              mode="javascript"
              readOnly={true}
            />
          </List.Item>
        )}
      />
    </ConfigProvider>
    <StyledFooter>
      <Button
        icon={<Plus style={{ height: 16, margin: '-3px 3px' }} />}
        type="primary"
        data-testid="create-new-macro-button"
        onClick={ -> history.push("/#{ spaceId }/settings/forms/new")}
        shape="round"
        size="large"
        disabled={!WeaverService.userCanEdit()}
      >
        Add a new Form
      </Button>
    </StyledFooter>
  </PageContainer>

export default withRouter(Macros)
